module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/ic-success@2x.28c9cc61.png";